<template>
  <div id="scroll-board">
    <dv-border-box-6>
      <div class="table-name" style="text-align: center; padding-top: 8px">
        <img src="./img/icon6.png" />操作记录信息
      </div>
      <dv-scroll-board style="margin-top: -1px; " :config="config" />
    </dv-border-box-6>
  </div>
</template>

<script>
export default {
  name: 'ScrollBoard',
  data () {
    return {
      config: {
        header: ['插槽', '子插槽', '元件', '类型', '状态', '备注', '操作时间'],
        data: [],
        index: false,
        columnWidth: [150, 120, 230, 100, 100, 200, 230],
        align: ['center'],
        headerHeight: 45,
        oddRowBGC: 'rgba(9, 37, 50, 0.4)',
        evenRowBGC: 'rgba(10, 32, 50, 0.3)',
        headerBGC: 'rgba(9, 37, 50, 0.4)',
        rowNum: 18,
        waitTime: 1200
      },
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 30000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderFeedingInfo',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.config.data = data.map((item) => [item.slotName, item.subSlotName ? item.subSlotName : "-",
        item.materialCode, this.formatFeedingType(item.feedingStatus), this.formatFeedingStatus(item.feedingStatus),
        item.remark ? item.remark : "-", this.formatDateTime(item.createTime)]);
      this.config = { ...this.config };
    },
    formatDateTime(value) {
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        let Y = date.getFullYear()
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours() // 时
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()// 分
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()// 秒
        s = s < 10 ? ('0' + s) : s
        return Y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },
    formatFeedingType(value) {
      if (value == 0 || value == 1){
        return '首检';
      }else if (value == 2 || value == 3){
        return '上料';
      }else if (value == 4 || value == 5){
        return '续料';
      }else if (value == 6 || value == 7){
        return '退料';
      }else if (value == 8 || value == 9){
        return '巡检';
      }else if (value == 10 || value == 11){
        return '核检';
      }
    },
    formatFeedingStatus(value) {
      if (value == 1 || value == 3 || value == 5 || value == 7 || value == 9 || value == 11){
        return '<span style="background-color: red; padding: 6px">错误</span>';
      }else if (value == 0 || value == 2 || value == 4 || value == 6 || value == 8 || value == 10){
        return '<span style="background-color: green; padding: 6px">成功</span>';
      }else {
        return '-';
      }
    }
  }
}
</script>

<style lang="less">
#scroll-board {
  width: 65%;
  height: calc(100% - 320px);
  box-sizing: border-box;
  margin-left: 20px;
  /*height: 100%;*/
  overflow: hidden;
  position: absolute;
  left: 32%;
  top: 195px;
}

.border-box-content {
  padding: 20px;
  box-sizing: border-box;
}

.table-name {
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;

  img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}

.dv-scroll-board {
  height: calc(~"100% - 60px");
}

#scroll-board-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}
</style>
